export default [
  {
    path: '/questionsAndGifts/prizeDetail',
    meta: { title: '奖品详情' },
    component: () =>
      import(
        /* webpackChunkName: "questionsAndGifts" */ '../../pages/questionsAndGifts/prizeDetail.vue'
      )
  }
]
